/**
 * This is used for Booza UI app configuration.
 */
const AppConfig = {
  // Shows the maintenance page instead of the login page. Set to true and
  // rebuild/redeploy to take the site into maintenance mode, false to switch
  // back to normal login.
  MAINTENANCE_MODE: true,

  // https://api.booza.com/api/ or http://localhost:8080/api/
  REST_END_POINT: 'https://api.booza.com/api/',

  // https://www.booza.com/api/ or http://localhost:8080/api/
  WEB_SITE_REST_API: 'https://www.booza.com/api/',

  // wss://api.booza.com:8443 or ws://localhost:8080
  WS_END_POINT: 'wss://api.booza.com:8443',

  // https://www.booza.com or http://localhost:8080/booza
  WEB_SITE_HOME_PAGE: 'https://www.booza.com',

  // https://play.booza.com or http://localhost:8084/
  WEB_SITE_PLAY_PAGE: 'https://play.booza.com',

  // wager smart contact address
  SMART_CONTRACT_ADDRESS: '0x02a206e54da793c38234a77c0ebece39490d812e',

  // Coin Gekio REST API call to get the crypto prices
  COIN_GEKIO_REST_API: 'https://api.coingecko.com/api/v3/simple/price?ids=fantom%2Cethereum%2Cbinancecoin%2Cavalanche-2%2Cmatic-network&vs_currencies=usd',

  // path to the game server
  GAME_SERVER_PATH: '/game-server/',

  // action constants
  SELECT_GAME: 'selectgamekind',
  LOGIN: 'login',
  LOGOUT: 'logout',
};

export default AppConfig;
